import {UserGroup} from "../models/user_group";
import {fetchSinglePageCollection, get, httpDelete, putStatusCode} from "./generic_repository";
import {PaginatedList} from "../components/paginated_list/paginated_sublist";
import {User} from "../models/user";
import { FilterParam } from "../models/barbagli/filter_order";

export async function fetchAllGroups (): Promise<UserGroup[]>  {
    const resp = await fetchSinglePageCollection<UserGroup>("/api/v1/user/group")(1, 8);
    if(typeof resp === 'string') return [];
    return resp.sublist;
}

export async function fetchUserGroups(userId: string): Promise<UserGroup[]>  {
    const resp = await fetchSinglePageCollection<UserGroup>(`/api/v1/user/${userId}/group`)(1, 8);
    if(typeof resp === 'string') return [];
    return resp.sublist;
}

export async function fetchCurrentUserPermissions() {
    const resp = await get("/api/v1/user/me")
    try {
        return {permissions: resp.data.attributes.permissions, type: resp.data.attributes.type}
    } catch(e) {
        console.error(e);
        return []
    }
}


export async function addUserToGroup(userId: string, groupId: string): Promise<boolean>  {
    // console.log(`Adding ${userId} to group ${groupId}`);
    const status = await putStatusCode("", `/api/v1/user/${userId}/group/${groupId}`);
    return status === 204;
}

export async function removeUserToGroup(userId: string, groupId: string): Promise<boolean>  {
    // console.log(`Removing ${userId} to group ${groupId}`);
    const status = (await httpDelete(`/api/v1/user/${userId}/group/${groupId}`)).status;
    return status === 204;
}

export const fetchPaginatedUsers: (url: string, cached?: boolean) => (selectedPage: number, perPage: number) => Promise<PaginatedList<User> | string> = (url: string, cached?: boolean) => async (selectedPage: number, perPage: number) => {
    try {
        //  min page is 1 so offset in this case should be 0
        const offset = (perPage * selectedPage) - perPage;

        if(cached) {
            const r = window.sessionStorage.getItem(url);
            if(r) return JSON.parse(r);
        }

        const responseCurrentPage = await get(`${url}${url.includes("?") ? "&" : ""}per_page=${perPage}&page=${selectedPage}`);
        if(responseCurrentPage.status > 300) {
            return `Error, status ${responseCurrentPage.status}`;
        }

        const nextPageCount = (await get(`${url}${url.includes("?") ? "&" : ""}per_page=${perPage}&page=${selectedPage}`))?.data?.length ?? 0;

        const sublist = (responseCurrentPage.data).map((a: { attributes: User }) => a.attributes) as User[];

        const r = {
            sublist,
            count: perPage + offset + nextPageCount,
            perPage,
            selectedPage
        }

        if(cached) {
            window.sessionStorage.setItem(url, JSON.stringify(r));
        }

        return r;

    } catch (e) {
        return e.toString();
    }
};

export const deleteUser = async (id: string) => {
    try {
        const result = await httpDelete('/api/v1/user/' + id.toString());
        if(result.status === 204) return "";
        return result.status.toString();

    } catch (e) {
        console.log(e);
        return e.toString();
    }
}

